﻿var subscribeForm = function () {
	$(function () {
		if ($("#subscribe-form").length > 0) {
			$("#subscribe-form").validate({
				submitHandler: function () {

					$.ajax({
						type: "POST",
						url: "/umbraco/surface/hubspot/addcontact",
						data: {
							emailAddress: $("#subscribe").val()
						},
						success: function (data) {
							debugger;

							if (data.result === "1") {
								$("#subscribe-form").html("<span class=\"c-subscribe-form__label\" style=\"width:100% !important\">" + data.message + "</span>");
							}
							else if (data.result === "0") {
								$("#subscribe-form").html("<span class=\"c-subscribe-form__label\" style=\"width:100% !important\">" + data.message + "</span>");
							}
						},
						error: function () {
							alert("An error has occured while signing up. Please try again.");
						}
					});

					return false;
				}
			});
		}
	});
}

module.exports = subscribeForm;